export const ADDITIONAL_PARTICIPANTS_LIMIT = 5
export const ADDITIONAL_RIDERS_LIMIT = 25
